export const base = 'https://32democrats.org'
export const codename = '32LDDO'
